export default __webpack_public_path__ + "static/media/Poppinsbold.f80def02.woff2";